import React, { useEffect, useState } from 'react';
import './Details.css';
import { Link } from 'react-router-dom';
import { api } from '../api';

// Source symbol (?s=) comes from the application record (api/applications.php)
function getSource(app) {
  return app?.source ?? 's';
}

function imageUrl(element) {
  if (element.imageSrc && element.imageSrc.startsWith('http')) return element.imageSrc;
  return 'https://admin.tablemate.net/sites/default/files/' + (element.imageSrc || '').replace('public://', '');
}

// Parse category's application field as comma-separated list (supports multiple applications per category)
function categoryApplicationList(cat) {
  if (!cat.application) return [];
  return String(cat.application)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

function Home() {
  const [applications, setApplications] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get('/api/applications.php'),
      api.get('/api/categories.php'),
    ])
      .then(([apps, cats]) => {
        setApplications(Array.isArray(apps) ? apps : []);
        setCategories(Array.isArray(cats) ? cats : []);
        setError(null);
      })
      .catch((err) => {
        setError(err?.error || 'Failed to load');
        setApplications([]);
        setCategories([]);
      })
      .finally(() => setLoading(false));
  }, []);

  // For each application, get categories that list this application (category application is comma-separated list)
  // Only include applications that have at least one category
  const categoriesByApplication = applications
    .map((app) => ({
      application: app,
      categories: categories.filter((cat) =>
        categoryApplicationList(cat).includes(app.name)
      ),
    }))
    .filter(({ categories: cats }) => cats.length > 0);

  if (loading) {
    return (
      <div className="details-container-page">
        <div>
          <h2 className="detailTitle">App Sections</h2>
        </div>
        <p>Loading…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="details-container-page">
        <div>
          <h2 className="detailTitle">App Sections</h2>
        </div>
        <p style={{ color: '#c00' }}>{error}</p>
      </div>
    );
  }

  return (
    <div className="details-container-page">
      <div>
        <h2 className="detailTitle">App Sections</h2>
      </div>
      {categoriesByApplication.map(({ application: app, categories: cats }, index) => (
        <React.Fragment key={app.id}>
          {index > 0 && <hr />}
          <h3>{app.name}</h3>
          <div className="button-grid row">
            {cats.map((cat) => (
              <div className="details-button col-4" key={cat.uri}>
                <Link to={`${cat.uri}?s=${getSource(app)}`}>
                  <img src={imageUrl(cat)} alt={cat.labelText || cat.uri} className="button-icon" />
                </Link>
                <div>{cat.labelText || cat.uri}</div>
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
      {applications.length === 0 && (
        <p style={{ color: '#888' }}>No applications yet. Add them in Admin → Applications.</p>
      )}
      {applications.length > 0 && categoriesByApplication.length === 0 && (
        <p style={{ color: '#888' }}>No articles for any application yet.</p>
      )}
    </div>
  );
}

export default Home;
